export enum StorageKeysEnum {
  jwt = 'jwt',
  refreshToken = 'refreshToken',
  i18nextLng = 'i18nextLng',
  selections = 'selections',
  redirectUrl = 'redirectUrl',
  clientToken = 'clt',
}
